module.exports = __webpack_public_path__ + "img/6.ca362914.png";